import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TagInterface } from './definitions/tag-interface';
import { ErrorsInterface } from '../errors/errors-interface';
import { Observable } from 'rxjs';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface TagUpdateResponse {
  Tag: {
    create: {
      output: Array<TagInterface>;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class TagUpdateService {
  constructor(private apollo: Apollo) {}

  updateTag(
    tag: TagInterface,
    mutation: DocumentNode
  ): Observable<FetchResult<TagUpdateResponse>> {
    return this.apollo.mutate<TagUpdateResponse>({
      mutation: mutation,
      variables: {
        id: tag.id,
        text: tag.text,
        color: tag.color,
      },
    });
  }
}
